import axios from "axios";
export class ClearService {
    constructor(authService, environment) {
        this.authService = authService;
        this.environment = environment;
    }
    async getVerificationSession(organizationId, redirectUrl) {
        const response = await axios.post(`${this.environment.API_BASE_URL}/clear/verify`, { organizationId, redirectUrl });
        return response.data;
    }
    async getIAL2Url(organizationId, redirectUrl, useFallback) {
        const response = await axios.post(`${this.environment.API_BASE_URL}/clear/ial2-url`, { organizationId, redirectUrl, useFallback });
        return response.data;
    }
}
